// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.taModal.modal label {
  font-weight: normal;
  margin-bottom: 2px;
}

.ta .radio {
  display: inline-block;
}

.ta .radio + .radio {
  margin-left: 3rem;
}

#enforceOrderContainer .radio + .radio {
  margin-left: 3rem;
}
`, "",{"version":3,"sources":["webpack://./apps/lms/src/css/components/premiumAdmin/forms.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB","sourcesContent":[".taModal.modal label {\n  font-weight: normal;\n  margin-bottom: 2px;\n}\n\n.ta .radio {\n  display: inline-block;\n}\n\n.ta .radio + .radio {\n  margin-left: 3rem;\n}\n\n#enforceOrderContainer .radio + .radio {\n  margin-left: 3rem;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
